module.exports = __webpack_public_path__ + "static/media/IMG_0242.6a4f8c83.jpg";